import * as React from 'react';

import { ValidatorResult } from 'shared/entities/validator';
import TextArea from 'shared/newComponents/form/TextArea';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';
import {
  getManagerSegmentTextLength,
  MANAGER_SEGMENT_OTHER_TEXT_MAX_LENGTH
} from 'shared/entities/managerSegment';

import './OtherTextField.modules.scss';

type Props = {
  id: string;
  value: string;
  error: ValidatorResult;
  disabled: boolean;
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
};

const OtherTextField: React.FC<Props> = ({
  id,
  value,
  error,
  disabled,
  label,
  placeholder,
  onChange
}: Props) => {
  const errorId = `${id}-error`;

  return (
    <div styleName="other-text-field">
      <TextArea
        id={id}
        value={value}
        error={error}
        errorId={errorId}
        disabled={disabled}
        label={label}
        placeholder={placeholder}
        aria-label={label}
        minRows={2}
        maxRows={4}
        aria-describedby={error ? errorId : undefined}
        onChange={onChange}
      />
      <Typography
        Element="span"
        fontType={TypographyType.text}
        fontSize={TypographySize.xs}
        fontColor={TypographyColor.tertiary}
        styleName="other-text-field__counter"
      >
        {`${getManagerSegmentTextLength(value)} / ${MANAGER_SEGMENT_OTHER_TEXT_MAX_LENGTH}`}
      </Typography>
    </div>
  );
};

export default React.memo(OtherTextField);
